import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Menu, notification, Dropdown } from 'antd'
import more from 'icons/More.svg'
import styled from 'styled-components'
import lang from 'lang/en'
import { getCookie } from 'helper/cookie'
import '../../../styleLess/signature/supportneed.scss'
import { Table } from 'antd'
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MailOutlined,
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import Emytystate from 'icons/createproject/supportneed.svg'
const initalState = {
  data: [],
  isLoading: true,
}
import loadingAnimationthreedot from 'icons/three-dots.svg'
import ModalAddSupportNeed from 'common/SupportNeed/ModalAdd'
import ModalDeleteSupportNeed from 'common/SupportNeed/ModalDelete'
import { useHistory } from 'react-router-dom'
const Header = styled.div``
const Body = styled.div``
const ContainerSN = styled.div``
const { TextArea } = Input
import { Helmet } from 'react-helmet'
import {
  getResultSupportNeed,
  getResultOptionSupportNeed,
  updateStatusSupportNeed,
  sendMailSupportNeed,
} from 'api/Project/supportneed'
const SubContainer = styled.div``
const EmptyState = styled.div``
const ConatainerSUP = styled.div``

const Supportneed = (props) => {
  const {
    idEditPRJ,
    swithCaseFunction,
    checkCanEditProjectByStatus,
    memberRole,
    checkStatusWaiting,
    form,
    setVisibleSaveDraft,
    checkBtn,
    canNotEditProject,
  } = props

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  const [dataSupportNeed, setDataSupportNeed] = useState(initalState.data)
  const [modalState, setModalState] = useState(false)

  const [visibleDelete, setVisibleDelete] = useState(false)
  const [searchTerm, setsearchTerm] = useState(0)
  const companyIDUser = getCookie('companyId_project')

  const [dataEdit, setDataEdit] = useState(initalState.data)
  const [waitingData, setWaitingData] = useState(false)
  const history = useHistory()
  //option
  const [dataOption, setDataOption] = useState(initalState.data)
  const [disableSelect, setDisableSelect] = useState(false)

  //typeBtn
  const [typeBtn, setTypeBtn] = useState()

  //view
  const [viewNameBtn, setViewNameBtn] = useState('')
  const [viewDisplayOk, setViewDisplayOk] = useState('')
  const [viewDisable, setViewDisable] = useState(false)

  //check rolee
  //ต้อง !rolee เพราะว่า หน้า createprojectstep1 ส่งมาเป็น cannot

  const [disableBtnPage, setDisableBtnPage] = useState(false)

  const getSupportNeed = async () => {
    getResultSupportNeed({
      project_id: parseInt(idEditPRJ),
      sprintflow_id: 0,
      taskinbox: 'N',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataSupportNeed([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataSupportNeed(data)
          setWaitingData(true)
        } else {
          setWaitingData(true)
          setDataSupportNeed([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setWaitingData(true)
        setDataSupportNeed([])
        setIsLoading(false)
        console.error(error)
      })
  }

  //get option
  const getOption = async () => {
    getResultOptionSupportNeed({
      company_id: parseInt(companyIDUser),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOption([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataOption(data)
        } else {
          setDataOption([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (memberRole) {
      if (memberRole > 3) {
        setDisableBtnPage(true)
        setDisableSelect(true)
      } else {
        if (checkCanEditProjectByStatus == false || canNotEditProject == true) {
          setDisableBtnPage(true)
        } else {
          setDisableBtnPage(false)
        }
        if (checkStatusWaiting == true) {
          setDisableSelect(true)
        } else {
          setDisableSelect(false)
        }
      }
    }
  }, [memberRole, checkCanEditProjectByStatus, checkStatusWaiting])

  useEffect(() => {
    if (token) {
      getOption()
      getSupportNeed()
    }
  }, [token])

  const openNotificationWithIcon = (type, data, value) => {
    if (value == 'Done') {
      notification[type]({
        message: 'Success',

        description: 'You have been ' + value.toLowerCase() + '.',
        duration: 3,
      })
    } else {
      notification[type]({
        message: 'Success',
        description: 'You have been ' + value.toLowerCase() + 'ed.',
        duration: 3,
      })
    }
  }

  const onChange = (value, data) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: 0,
      support_status: value,
    }
    try {
      updateStatusSupportNeed({
        supportneed_id: data.dataAll.id,
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getSupportNeed()
          openNotificationWithIcon('success', data, value)
        } else {
          console.log(res.status)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  const onClickSendMail = (data) => {
    try {
      sendMailSupportNeed({
        supportneed_id: data.id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getSupportNeed()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const ButtonSiteEliter = (data) => {
    if (disableBtnPage === true) {
      return (
        <Button id='btn_sendMail' className='BTN_Previous' disabled={true}>
          <MailOutlined className='Icon-color' /> Send Mail
        </Button>
      )
    } else {
      if (data.dataAll.sendmail_status != 'Y' && data.dataAll.enable_button != 'N') {
        return (
          <Button
            id='btn_sendMail'
            className='BTN_Previous'
            onClick={() => onClickSendMail(data)}
            disabled={false}
          >
            <MailOutlined className='Icon-color' /> Send Mail
          </Button>
        )
      } else {
        return (
          <Button id='btn_sendMail' className='BTN_Previous' disabled={true}>
            <MailOutlined className='Icon-color' /> Send Mail
          </Button>
        )
      }
    }
  }

  const View = (data) => {
    setModalState(true)
    setViewDisable(true)
    setViewDisplayOk('none')
    setViewNameBtn('Close')
    setDataEdit(data)
    setTypeBtn('edit')
  }

  const toolSiteEliter = (data) => {
    if (data.dataAll.sendmail_status == 'Y') {
      return (
        <div>
          <EyeOutlined onClick={() => View(data)} className='eyeoutlined' />
        </div>
      )
    } else {
      return (
        <Row style={{ flexWrap: 'nowrap' }}>
          <EditOutlined
            style={{ cursor: disableBtnPage ? 'no-drop' : 'pointer' }}
            className='editoutlined'
            onClick={() => Editremark(data)}
          />
          <DeleteOutlined
            style={{ cursor: disableBtnPage ? 'no-drop' : 'pointer' }}
            className='deleteoutlined'
            onClick={() => Deleteremark(data)}
          />
        </Row>
      )
    }
  }
  const menu = (data) => {
    if (data.dataAll.sendmail_status == 'Y') {
      return (
        <Menu>
          <Menu.Item key='0' onClick={() => View(data)}>
            View
          </Menu.Item>
        </Menu>
      )
    } else {
      return (
        <Menu>
          <Menu.Item key='1' onClick={() => Editremark(data)}>
            Edit
          </Menu.Item>
          <Menu.Item key='2' onClick={() => Deleteremark(data)}>
            Delete
          </Menu.Item>
        </Menu>
      )
    }
  }
  const Editremark = (value) => {
    if (disableBtnPage === true) {
    } else {
      setViewDisable(false)
      setViewDisplayOk('')
      setViewNameBtn('')

      setTypeBtn('edit')
      setModalState(true)
      setDataEdit(value)
    }
  }
  const Deleteremark = (value) => {
    if (disableBtnPage === true) {
    } else {
      setDataEdit(value)
      setVisibleDelete(true)
    }
  }

  const dataSource = dataSupportNeed
    .filter((item) => {
      if (searchTerm === 0 || searchTerm === undefined) {
        return item
      } else if (searchTerm === item.support_status) {
        return item
      }
    })
    .map((item) => ({
      id: item.id,
      key: item.id,
      remark: item.description,
      status: item.support_status,
      type: item.support_type_id,
      dataAll: item,
    }))

  const columns = [
    {
      title: <h5 style={{ fontFamily: 'IBMPlexSansThaiBold' }}>Remark</h5>,
      dataIndex: 'remark',
      key: 'remark',
      render: (text) => <p className='remark-style'>{text}</p>,
    },
    {
      title: <h5 style={{ fontFamily: 'IBMPlexSansThaiBold' }}>Type</h5>,
      dataIndex: 'type',
      key: 'type',

      render: (text) => {
        dataOption.map((item) => {
          if (text == item.id) {
            text = item.title
          }
        })
        return text
      },
    },
    {
      title: (
        <h5 style={{ paddingLeft: 20, fontFamily: 'IBMPlexSansThaiBold' }}>Status</h5>
      ),
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status, data) => {
        if (status == 'Done') {
          return <p style={{ marginLeft: 11 }}>Done</p>
        } else {
          return (
            <Select
              className='selectionassignee'
              placeholder='dropdown'
              style={{ width: 120 }}
              onChange={(e) => onChange(e, data)}
              defaultValue={status}
              disabled={disableSelect}
            >
              {mockStatusType.map((item) => (
                <Option value={item.status_name}>{item.status_name}</Option>
              ))}
            </Select>
          )
        }
      },
    },
    {
      title: (
        <h5 className='actionT' style={{ fontFamily: 'IBMPlexSansThaiBold' }}>
          Action
        </h5>
      ),
      render: (data) => <div className='item-container'>{toolSiteEliter(data)}</div>,
    },
    {
      title: '',
      render: (data) => <div className='item-container'>{ButtonSiteEliter(data)}</div>,
    },
  ]

  const [mockStatusType, setmockStatusType] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      id: 2,
      status_name: 'In Progress',
      key: 'inprogress',
    },
    {
      id: 3,
      status_name: 'Done',
      key: 'done',
    },
    {
      id: 4,
      status_name: 'Cancel',
      key: 'cancel',
    },
  ])

  const FilterData = () => {
    return (
      <Table
        className='mytable-supportneed-project'
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    )
  }

  const showModalStateAdd = () => {
    setViewDisable(false)
    setViewDisplayOk('')
    setViewNameBtn('')
    setTypeBtn('add')
    setModalState(true)
  }

  const playStateHeader = () => {
    if (dataSupportNeed.length == 0) {
      return <div></div>
    } else {
      return (
        <Col className='col2'>
          <Select
            className='Select Select-Custom'
            placeholder='All '
            style={{ minWidth: '297px', borderRadius: '4px' }}
            size='large'
            allowClear
            showSearch
            optionFilterProp='children'
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) => onChangeSearch(e)}
          >
            <Option value={0}>All</Option>
            {mockStatusType.map((item) => (
              <Option value={item.status_name}>{item.status_name}</Option>
            ))}
          </Select>
          <Button
            id='btn_addSup'
            disabled={disableBtnPage}
            className='BTN_Next'
            onClick={() => showModalStateAdd()}
            style={{ marginLeft: '14px' }}
          >
            <PlusOutlined className='Icon-color' />
            Add New
          </Button>
        </Col>
      )
    }
  }
  let arrayData = []
  const playStateBody = () => {
    if (dataSupportNeed.length == 0) {
      return (
        <ConatainerSUP className="containerSUP">
          <SubContainer className='sub-container'>
            <EmptyState className="empty-sup">
              <img className='bigicon' src={Emytystate}></img>
              <h2>Please add Support need in your project (optional)</h2>
              <Button
                id='btn_addSup'
                className='BTN_Next'
                disabled={disableBtnPage}
                onClick={() => showModalStateAdd()}
              >
                <PlusOutlined className='Icon-color' /> Add New Support Need
              </Button>
            </EmptyState>
          </SubContainer>
        </ConatainerSUP>
      )
    } else {
      return (
        <div>
          {dataSource &&
            dataSource.filter((item) => {
              if (searchTerm === 0 || searchTerm === undefined) {
                arrayData.push(item)
              } else if (searchTerm === item.status) {
                arrayData.push(item)
              }
            })}
          <div className='layout-table-supportneed'>
            <div className='desktop-style'>{FilterData()}</div>
            <div className='mobile-style'>{MobileShowcard()}</div>
          </div>
        </div>
      )
    }
  }

  const MobileShowcard = () => {
    return (
      <div className='content-mapping'>
        {dataSource.map((itemMain) => {
          return (
            <div className='Box-spn'>
              <Row className='remark-row'>
                <div>
                  <span className='small'>Remark</span>
                  <div style={{ display: 'grid', width: '95%' }}>
                    <p className='cutter-text-line-1'>{itemMain.remark}</p>
                  </div>
                </div>
                <div className='action-event'>{renderDropdown(itemMain)}</div>
              </Row>
              <Row className='type-row'>
                <span className='small'>Type</span>
                {dataOption.map((item) => {
                  if (item.id === itemMain.type) {
                    return <p>{item.title}</p>
                  }
                })}
              </Row>
              <Row className='status-row'>
                <div className='status-left-content'>
                  <span className='small'>Status</span>
                  <div>{renderSelectStatus(itemMain.status, itemMain)}</div>
                </div>
                {ButtonSiteEliter(itemMain)}
              </Row>
            </div>
          )
        })}
      </div>
    )
  }
  const renderDropdown = (data) => {
    return (
      <Dropdown overlay={(e) => menu(data)} trigger={['click']} placement='bottomRight'>
        <a>
          <img src={more} />
        </a>
      </Dropdown>
    )
  }

  const renderSelectStatus = (status, data) => {
    if (status == 'Done') {
      return <p>Done</p>
    } else {
      return (
        <Select
          className='selectionassignee'
          placeholder='dropdown'
          style={{ width: 120 }}
          onChange={(e) => onChange(e, data)}
          value={status}
          disabled={disableSelect}
        >
          {mockStatusType.map((item) => (
            <Option value={item.status_name}>{item.status_name}</Option>
          ))}
        </Select>
      )
    }
  }

  const onChangeSearch = (value) => {
    setsearchTerm(value)
  }

  const onClickNext = () => {
    swithCaseFunction('sprintflow')
    history.push(`/project/${idEditPRJ}/sprintflow`)
  }
  const onClickPrevious = () => {
    swithCaseFunction('kpi')
    history.push(`/project/${idEditPRJ}/kpi`)
  }

  const footer = () => {
    return (
      <div>
        <Button
          id='previoussupportneed'
          type='primary'
          className='BTN_Previous'
          style={{ marginRight: 8 }}
          onClick={() => onClickPrevious()}
        >
          <LeftOutlined className='Icon-color' />
          Previous
        </Button>
        <Button
          id='previoussupportneed'
          type='primary'
          className='BTN_Next '
          onClick={() => onClickNext()}
        >
          Next
          <RightOutlined className='Icon-color' />
        </Button>
      </div>
    )
  }
  //เพื่อแสดง modal saveDraft
  const onFinishSave = () => {
    if (checkBtn == 'save') {
      setVisibleSaveDraft(true)
    }
  }

  return (
    <ContainerSN className='container-sn'>
      <Helmet>
        <title>Create Project | Support Need</title>
      </Helmet>
      <Form form={form} onFinish={onFinishSave}></Form>
      <Header className='header'>
        <Row className='row'>
          <Col className='col1'>
            <h2>Support Need</h2>
          </Col>
          {playStateHeader()}
        </Row>
      </Header>
      {waitingData === true ? (
        <Body className='body'>
          <div> {playStateBody()}</div>
          <Row style={{ marginTop: 32 }} justify='end'>
            {footer()}
          </Row>
        </Body>
      ) : (
        <div className='container-waiting-load'>
          <img src={loadingAnimationthreedot}></img>
        </div>
      )}

      <ModalAddSupportNeed
        setModalState={setModalState}
        modalState={modalState}
        viewNameBtn={viewNameBtn}
        viewDisplayOk={viewDisplayOk}
        viewDisable={viewDisable}
        dataEdit={dataEdit}
        typeBtn={typeBtn}
        idEditPRJ={idEditPRJ}
        getSupportNeed={getSupportNeed}
        stateKPI={'project'}
        pageTaskInboxDetail={'createproject'}
      />
      <ModalDeleteSupportNeed
        idEditPRJ={idEditPRJ}
        setVisibleDelete={setVisibleDelete}
        visibleDelete={visibleDelete}
        dataEdit={dataEdit}
        getSupportNeed={getSupportNeed}
        pageTaskInboxDetail={'createproject'}
      />
    </ContainerSN>
  )
}
// }
export default Supportneed
